export enum LORRY_STATUS {
    ALL = -1, //Dummy status - just incase to use in dropdown option
    ACTIVE = 3,
    IN_TRANSIT = 4,
    IN_ACTIVE = 0,
    STAND_BY = 5,
    VERIFICATION_FAILED = 999
}

export enum LORRY_STATUS_TEXT {
    ALL = "All",
    IN_ACTIVE = "In Active",
    ACTIVE = "Active",
    IN_TRANSIT = "In Transit",
    VERIFICATION_FAILED = "Verification Failed",
    STAND_BY = "Stand By"
}

export const ACTION_BY_LORRY_STATUS = {
    EDIT_LORRY: [LORRY_STATUS.ACTIVE],
    ADD_DRIVER_DETAILS: [LORRY_STATUS.ACTIVE, LORRY_STATUS.IN_TRANSIT]
};
